import { ProgressActionTypes as act } from './actionTypes';

export default function progress(
  state = {
    transactionType: undefined,
    currentStep: 0,
    previousStep: 0,
    // key/value pair of what progress flags are set--one time actions. Key is a flag constant in settings,
    // PROGRESS_FLAG_* and value is always true
    progressFlags: {},
  },
  { payload, type }
) {
  switch (type) {
    case `${act.SET_PROGRESS}_FULFILLED`: {
      const previousStep = state.currentStep;
      return {
        ...state,
        transactionType: payload.transactionType,
        previousStep,
        currentStep: payload.currentStep,
      };
    }
    case `${act.SET_FLAG}_FULFILLED`:
      return {
        ...state,
        progressFlags: {
          ...state.progressFlags,
          [payload.flag]: true,
        },
      };
    case `RESET_TRANSACTION`:
      return {
        currentStep: 1,
        previousStep: 0,
        // key/value pair of what progress flags are set--one time actions. Key is a flag constant in settings,
        // PROGRESS_FLAG_* and value is always true
        progressFlags: {},
      };
    default:
      return state;
  }
}
